import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  staffList: [],
  staffView: null,
  staffEdit: null,
  staffAll: [],
  staffDropdown: [],
  loading: false,
  error: null,
};

export const staffSlice = createSlice({
  name: "staff",
  initialState,
  reducers: {
    getStaff: (state, { payload }) => {
      state.staffList = payload;
    },
    setStaffList: (state, action) => {
      state.staffList = action.payload;
    },
    setStaffView: (state, action) => {
      state.staffView = action.payload;
    },
    setStaffEdit: (state, action) => {
      state.staffEdit = action.payload;
    },
    setStaffAll: (state, action) => {
      state.staffAll = action.payload;
    },
    setStaffDropdown: (state, action) => {
      state.staffDropdown = action.payload;
    },
  },
});

export const {
  getStaff,
  setStaffList,
  setStaffView,
  setStaffEdit,
  setStaffAll,
  setStaffDropdown,
} = staffSlice.actions;

export default staffSlice.reducer;
